import React, {FC, useEffect, useRef, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Tooltip} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {CHECKOUT_SIDE_BAR} from 'constants/analytics/events/checkout';

import s from './pointsInfoTooltip.scss';

type PropsType = {
    content: React.ReactNode;
    title: string;
    caption: string;
    offset: number;
    analyticsTitle: string;
    contentClassName: string;
};

/**
 * Points Info Tooltip
 * @constructor
 */
export const PointsInfoTooltip: FC<PropsType> = ({
    analyticsTitle,
    caption,
    content,
    contentClassName,
    offset,
    title,
}) => {
    const [isTooltipVisible, setTooltipVisibility] = useState<boolean>(false);

    const timeout = useRef<number>();

    useEffect(() => {
        if (isTooltipVisible) {
            timeout.current = window.setTimeout(() => {
                sendDesktopAnalyticsEvent(CHECKOUT_SIDE_BAR, {
                    message: `${analyticsTitle} - Hover`,
                });
            }, 3000);
        }
        return () => clearTimeout(timeout.current);
    }, [isTooltipVisible]);

    return (
        <Tooltip
            content={
                <div className={classNames(s.content, contentClassName)}>
                    <h3 className={s.caption}>{caption}</h3>
                    <div>{content}</div>
                </div>
            }
            closeTrigger="hover"
            isOpen={isTooltipVisible}
            offset={offset}
            onChange={changeValue => setTooltipVisibility(changeValue)}
            openTrigger="hover"
            position="bottom"
        >
            <div className={s.title}>{title}</div>
        </Tooltip>
    );
};
